import script from "./contentsDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./contentsDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./contentsDetailPage.vue?vue&type=style&index=0&id=56ca1b6d&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ca1b6d"]])

export default __exports__